import React from 'react';

export default function HintStrip() {
  return (
    <div className="mb-3.5 px-3.5 py-2.5 rounded-lg bg-[#FAFBFC] border border-lineSoft text-[12.5px] text-ink3 flex items-center gap-2 flex-wrap">
      <strong className="text-ink2">Tip:</strong>
      <span>paste rows from Excel or Google Sheets. Columns map to Number, Name, Type, Detail type in that order. Press</span>
      <span style={{ fontFamily: 'ui-monospace, monospace' }} className="bg-white border border-line rounded px-1.5 py-0.5 text-[11.5px] text-ink2">Tab</span>
      <span>to move between cells,</span>
      <span style={{ fontFamily: 'ui-monospace, monospace' }} className="bg-white border border-line rounded px-1.5 py-0.5 text-[11.5px] text-ink2">Enter</span>
      <span>to add a new row.</span>
    </div>
  );
}